<footer class="bg-white border-t border-gray-100 py-4">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-sm text-gray-500">
    &copy; {{ currentYear }} Mojica Panel Web. Todos los derechos reservados.
  </div>
</footer>